import { getToolbarElement } from './GetToolbarElement';

export const getStartAndEndButtons = ({
  startButtonDataHook,
  endButton,
}: {
  startButtonDataHook: string;
  endButton: HTMLButtonElement | string;
}) => {
  const startButton = getToolbarElement(startButtonDataHook);

  return {
    start: startButton,
    end: typeof endButton === 'string' ? getToolbarElement(endButton) : endButton,
  };
};
